import React from 'react';
import { AdLandingTemplate } from '../../components/templates/AdLandingTemplate';
import { Shield, Target, Zap, Users } from 'lucide-react';
export function TaekwondoNearMe() {
  return <AdLandingTemplate h1="Taekwondo & Martial Arts Near Farmington Hills" subheadline="Storm Taekwondo offers kids, adult and family martial arts classes for beginners and experienced students across Farmington Hills, Novi, Commerce, Livonia and nearby communities." ctaText="Find Your Class & Claim a Free Week" searchIntent="Taekwondo Classes Near You" heroImage="https://images.unsplash.com/photo-1555597673-b21d5c935865?auto=format&fit=crop&w=1200&q=80" benefits={[{
    icon: Shield,
    title: 'Confidence',
    description: 'Build self-esteem through structured progression and achievement.'
  }, {
    icon: Target,
    title: 'Focus',
    description: 'Develop mental clarity and concentration that carries off the mat.'
  }, {
    icon: Zap,
    title: 'Fitness',
    description: 'Improve strength, flexibility, and cardiovascular health.'
  }, {
    icon: Users,
    title: 'Community',
    description: 'Join a supportive, family-friendly environment.'
  }]} whatYouLearn={['Olympic-style Taekwondo techniques', 'Practical self-defense fundamentals', 'Improved balance, coordination, and agility', 'Goal setting through the belt ranking system', 'Discipline and respect for oneself and others']} faqs={[{
    question: 'Where are you located?',
    answer: 'We are conveniently located at 24786 Crestview in Farmington Hills, MI, easily accessible from Novi, Commerce, Livonia, and surrounding areas.'
  }, {
    question: 'Do you offer classes for beginners?',
    answer: 'Yes! The majority of our new students start with no prior martial arts experience. We have dedicated beginner classes for all age groups.'
  }, {
    question: 'What age groups do you teach?',
    answer: 'We teach ages 3 and up. We have Mini Troopers (ages 3-5), Kids Taekwondo (ages 6+), Adult classes, and Family classes where parents and kids can train together.'
  }, {
    question: 'How do I get started?',
    answer: 'Fill out the form on this page to claim your free one-week trial. We will contact you to confirm the best class time for your first visit.'
  }]} metaTitle="Taekwondo Near Me | Martial Arts Farmington Hills | Storm Taekwondo" metaDescription="Looking for Taekwondo or martial arts near Farmington Hills, Novi, Commerce or Livonia? Storm offers kids, adult and family classes. Free trial available." data-id="element-604" />;
}